/* Bande du haut — Le Temple du Foot (31/10/2026) : roulement de phrases de réassurance.
   Les phrases se modifient ici (HTML autorisé) ; EVERY = durée d’affichage de chaque phrase en ms. */
(function(){
  var MSGS=[
    '<span class="yk-topbar-badge">Limité</span> 3 achetés = 1 maillot offert !',
    'Service client 7 jours sur 7',
    'Paiement 100 % sécurisé',
    'Livraison suivie'
  ];
  var EVERY=3200;
  function boot(){
    var c=document.querySelector('.yk-topbar-center');if(!c||c.classList.contains('yk-topbar-rot'))return;
    c.innerHTML='';c.classList.add('yk-topbar-rot');
    var els=MSGS.map(function(h,i){var d=document.createElement('div');d.className='yk-topbar-msg'+(i?'':' is-on');d.innerHTML=h;c.appendChild(d);return d;});
    if(els.length<2||(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches))return;
    var i=0;setInterval(function(){if(document.hidden)return;els[i].classList.remove('is-on');i=(i+1)%els.length;els[i].classList.add('is-on');},EVERY);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
